export const userRoles = {
  user: 'user',
  admin: 'admin',
  ipfilter: 'ipfilter'
}
